import { render } from "./FriendSuggest.vue?vue&type=template&id=3fdbf881"
import script from "./FriendSuggest.vue?vue&type=script&lang=js"
export * from "./FriendSuggest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__